import BaseMapper from '../../BaseMapper';

const MainMarketDescriptionMapper = (data, context) => {
    return data;
};

export default MainMarketDescriptionMapper;
